import { render, staticRenderFns } from "./ModalBeneficio.vue?vue&type=template&id=cd9b54d6&scoped=true"
import script from "./ModalBeneficio.vue?vue&type=script&lang=js"
export * from "./ModalBeneficio.vue?vue&type=script&lang=js"
import style0 from "./ModalBeneficio.vue?vue&type=style&index=0&id=cd9b54d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd9b54d6",
  null
  
)

export default component.exports